export const seoUseCaseKeyWords = function(businesType:string,activityBookingDescription:string):string{return `${businesType},${businesType} Software, ${activityBookingDescription} Software, Book ${activityBookingDescription}s, App for ${activityBookingDescription}s`}


